import * as React from 'react';
import { PublicState as SliderValue } from 'rheostat';

import { Bem } from '../../service/Bem/Bem';
import { Slider, SliderTheme } from '../Slider/Slider';

import './PhraseTrafficForecast.css';

enum volumeLimits {
    low = 15,
    medium = 75
}

export interface PhraseTrafficForecastProps {
    value?: number;
    minValue: number;
    maxValue: number;
    disabled?: boolean;
    onValueChange?: (value: number) => void;
}

export class PhraseTrafficForecast extends React.PureComponent<PhraseTrafficForecastProps> {
    render() {
        const { value, minValue, maxValue, disabled } = this.props;

        return (
            <div className={Bem.cls('phrase-traffic-forecast')}>
                <div className={Bem.cls('phrase-traffic-focast', 'slider')}>
                    <Slider
                        theme={this.getSliderTheme()}
                        values={[value || minValue]}
                        min={minValue}
                        max={maxValue}
                        disabled={disabled}
                        onValuesUpdated={this.onValueChange}
                    />
                </div>

                <span className={Bem.cls('phrase-traffic-focast', 'value')}>{value !== undefined ? value : '–'}</span>
            </div>
        );
    }

    private onValueChange = (sliderState: SliderValue) => {
        if (this.props.onValueChange) {
            this.props.onValueChange(sliderState.values[0]);
        }
    };

    private getSliderTheme = () => {
        const { value } = this.props;

        if (!value) {
            return SliderTheme.error;
        }

        if (value > volumeLimits.medium) {
            return SliderTheme.success;
        } else if (value > volumeLimits.low) {
            return SliderTheme.warning;
        } else {
            return SliderTheme.error;
        }
    };
}
